<template>
    <Head title="My Credit Score" />
    <div class="px-4 md:px-8">
        <CreditScore />
    </div>
</template>
<script setup>
import { Head } from '@inertiajs/vue3';
import CreditScore from '@/components/creditscore/index.vue';
</script>
